<template>
  <PgTable
    class="pg-scan-result"
    ref="tableRef"
    height="auto"
    :treeNode="treeField ? 'seq' : ''"
    :column="column"
    :columnTableCode="columnTableCode"
    :seachKeys="seachKeys"
    :seachPlaceholder="seachPlaceholder"
    :buttonRow="buttonRow"
    :customAction="customAction"
  >
    <template #left v-if="items">
      <div class="pg-scan-result__table-left">
        <span class="pg-scan-result__table-left-text" v-for="item in taskText" :key="item.key">
          {{ item.title }}：<span class="pg-scan-result__table-left-num">{{
            taskNum[item.key]
          }}</span>
        </span>
      </div>
    </template>
  </PgTable>
</template>
<script setup>
import { PgTable } from '../../table/index'
import { clone, getValueByPath } from '../../../utils/index'
import { ref } from 'vue'
import { useTaskNum } from '../hook/use-task-num'

const props = defineProps({
  column: [Array, Object],
  columnTableCode: String,
  seachKeys: {
    type: Array,
    default: () => ['code'],
  },
  seachPlaceholder: String,
  //根据该字段转换为树状结构展示
  treeField: {
    type: String,
    default: 'goodsDetail.id',
  },
  //任务明细
  items: Array,
  // [{
  //   title: '计划数量',
  //   key: 'planTotal'
  // }, {
  //   title: '已扫数量',
  //   key: 'amountTotal'
  // },{
  //   title: '任务总数',
  //   key: 'taskTotal'
  // },{
  //   title: '当前待处理总数',
  //   key: 'taskRemaining'
  // },{
  //   title: '当前已扫总数',
  //   key: 'taskDone'
  // }]
  taskText: {
    type: Array,
    default: () => [
      {
        title: '计划数量',
        key: 'planTotal',
      },
      {
        title: '已扫数量',
        key: 'amountTotal',
      },
    ],
  },
})

const { taskNum, setTaskNum } = useTaskNum({ items: props.items })

const tableRef = ref(null)
//获取表格数据
const getTableData = () => {
  const { fullData } = tableRef.value.getTableData()
  return fullData.reduce((pre, cur) => {
    if (cur.children?.length > 0) {
      pre.push(...cur.children)
    } else {
      pre.push(cur)
    }
    return pre
  }, [])
}
//渲染表格数据
const loadData = (data) => {
  return tableRef.value.loadData(data)
}

//根据_ID查找表格行数据，如果存在表示修改行数据，根据参数调整该行位置并刷新表格
const getRowBy_ID = (id, tableData, unshift) => {
  if (!id) {
    return
  }
  for (let i = 0; i < tableData.length; i++) {
    if (tableData[i].children?.length > 0) {
      const res = getRowBy_ID(id, tableData[i].children, unshift)
      if (res) {
        const temRow = tableData[i]
        tableData.splice(i, 1)
        if (unshift) {
          tableData.splice(0, 0, temRow)
        } else {
          tableData.push(temRow)
        }
        return { tableData, children: tableData[i].children }
      }
    } else if (tableData[i]._ID === id) {
      const temRow = tableData[i]
      tableData.splice(i, 1)
      if (unshift) {
        tableData.splice(0, 0, temRow)
      } else {
        tableData.push(temRow)
      }
      return { tableData }
    }
  }
}

//设置表格组件
const setFullData = (tableData, row, unshift) => {
  const res = getRowBy_ID(row._ID, tableData, unshift)
  if (res) {
    return res
  }

  if (props.treeField) {
    if (tableData.length === 0) {
      tableData.push(row)
      return { tableData }
    }
    for (let i = 0; i < tableData.length; i++) {
      if (getValueByPath(tableData[i], props.treeField) === getValueByPath(row, props.treeField)) {
        if (tableData[i].children?.length > 0) {
          tableData[i].children = [row, ...tableData[i].children]
          const temRow = tableData[i]
          tableData.splice(i, 1)
          if (unshift) {
            tableData.splice(0, 0, temRow)
          } else {
            tableData.push(temRow)
          }
          return { tableData, children: tableData[i].children }
        } else {
          const children = clone(tableData[i])
          children._ID = null
          children.children = [row, tableData[i]]
          tableData.splice(i, 1)
          if (unshift) {
            tableData.splice(0, 0, children)
          } else {
            tableData.push(children)
          }
          return { tableData, children: children }
        }
      }
    }
    //没有相同的商品就直接添加
    if (unshift) {
      tableData.splice(0, 0, row)
    } else {
      tableData.push(row)
    }
    return { tableData }
  } else {
    if (unshift) {
      return { tableData: [row, ...tableData] }
    } else {
      return { tableData: [...tableData, row] }
    }
  }
}
//表格增加行数据， unshift为true时增加到表格第一行
const addRow = (row, unshift = true) => {
  const { fullData } = tableRef.value.getTableData()
  const { tableData, children } = setFullData(fullData ?? [], row, unshift)
  loadData(tableData).then(() => {
    setTimeout(() => {
      setTaskNum(tableData)
      tableRef.value.setCurrentRow(row)
      tableRef.value.setTreeExpand(children, true)
    })
  })
}

const buttonRow = ref([
  {
    code: 'ROW_REMOVE',
    name: '删除',
  },
])
const customAction = (menu, { row }) => {
  if (menu.code === 'ROW_REMOVE') {
    const { fullData } = tableRef.value.getTableData()
    for (let i = 0; i < fullData.length; i++) {
      if (fullData[i]._ID === row._ID) {
        fullData.splice(i, 1)
        loadData(fullData)
        return
      } else if (fullData[i].children?.length > 0) {
        for (let j = 0; j < fullData[i].children.length; j++) {
          if (fullData[i].children[j]._ID === row._ID) {
            fullData[i].children.splice(j, 1)
            if (fullData[i].children.length === 0) {
              fullData.splice(i, 1)
            }
            loadData(fullData)
            return
          }
        }
      }
    }
  }
}
defineExpose({
  getTableData,
  addRow,
})
</script>
<style lang="scss">
@import '../style/scan-result.scss';
</style>
